import { SVGProps } from 'react';

const IconPortal = (props: SVGProps<SVGSVGElement>) => (
  <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g filter="url(#filter0_i_2160_17)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5008 40C23.4086 40 26.1045 37.3899 26.1045 33.6306L26.1045 26.4532L12.8965 26.4532L12.8965 33.6306C12.8965 37.3899 15.5925 40 19.5008 40"
        fill="#F1DE02"
      />
    </g>
    <g filter="url(#filter1_i_2160_17)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70294e-06 20.0005C7.67042e-06 24.0085 2.54471 26.7735 6.21002 26.7735L13.026 26.7735L13.026 13.2268L6.21002 13.2268C2.54471 13.2268 7.73547e-06 15.9919 7.70294e-06 20.0005Z"
        fill="#009639"
      />
    </g>
    <g filter="url(#filter2_i_2160_17)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5001 -2.02918e-05C15.5923 -1.99414e-05 12.8965 2.60995 12.8965 6.36927L12.8965 13.5468L26.1045 13.5468L26.1045 6.36927C26.1045 2.60995 23.4085 -2.06423e-05 19.5001 -2.02918e-05"
        fill="#FF8300"
      />
    </g>
    <g filter="url(#filter3_i_2160_17)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 19.9998C39 15.9919 36.4553 13.2268 32.79 13.2268L25.792 13.2268L25.792 26.7736L32.79 26.7736C36.4553 26.7736 39 24.0084 39 19.9998Z"
        fill="#F40000"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_2160_17"
        x="12.8965"
        y="26.4532"
        width="13.208"
        height="17.5468"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2160_17" />
      </filter>
      <filter
        id="filter1_i_2160_17"
        x="0"
        y="13.2268"
        width="13.026"
        height="17.5468"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2160_17" />
      </filter>
      <filter
        id="filter2_i_2160_17"
        x="12.8965"
        y="0"
        width="13.208"
        height="17.5468"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2160_17" />
      </filter>
      <filter
        id="filter3_i_2160_17"
        x="25.792"
        y="13.2268"
        width="13.208"
        height="17.5468"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2160_17" />
      </filter>
    </defs>
  </svg>
);

export default IconPortal;
